import { ADMIN_ROLES } from '@/auth/roles';
import { RequireRole } from '@/auth/RequireRole';
import type { RouteObject } from 'react-router-dom';

/**
 * Trainers area. OWNED BY `m2-staff` (M2); see docs/BUILD-ORCHESTRATION.md.
 *
 *   /trainers              the team: list, add (drawer), switch on
 *   /trainers/:staffId     one staff member: members, profile, switch off/on
 *
 * Owner and admin only: a trainer never sees this area (CLAUDE.md "Roles"); typing the
 * address shows Not found. RLS and the RPCs are the real gate.
 */
export const trainersRoutes: RouteObject[] = [
  {
    path: 'trainers',
    handle: { crumb: 'Trainers' },
    element: <RequireRole roles={ADMIN_ROLES} />,
    children: [
      { index: true, lazy: async () => ({ Component: (await import('./TrainersPage')).TrainersPage }) },
      {
        path: ':staffId',
        handle: { crumb: 'Staff member' },
        lazy: async () => ({ Component: (await import('./TrainerProfilePage')).TrainerProfilePage }),
      },
    ],
  },
];
